import { Box, Stack, styled } from '@mui/material'
import { themeValue } from 'styles'

export const WalletSelection = styled(Stack)`
  gap: 8px;
`
export const WalletType = styled(Stack)`
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.text60};
`
export const WalletGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 8px;
`
export const WalletOption = styled('button')`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  font-weight: 600;
  padding: 20px 28px;
  gap: 16px;
  color: ${({ theme }) => theme.color.text80};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  background-color: transparent;
  border: none;
  border-left: 3px solid transparent;
  transition: border 0.1s ease;
  cursor: pointer;

  &:hover {
    border-color: rgba(160, 238, 9, 1);
    background-color: rgba(57, 65, 73, 1);
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
  }
`
export const WalletOptionIcon = styled(Stack)`
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  /* background: ${({ theme }) => theme.color.bg}; */
  overflow: hidden;
`
export const WalletOptionImg = styled('img')`
  width: 32px;
  height: 32px;
  overflow: hidden;
`
export const WalletOptionName = styled('div')`
  flex: 1;
  text-align: left;
`
export const WalletOptionDot = styled('span')`
  display: inline-block;
  width: 6px;
  height: 6px;
  background: ${({ theme }) => theme.color.notificationGreen02};
  border-radius: 50%;
`
